export class RoleInstitution {
  public id: any;
  public roleId: string;
  public institutionId: string;
  public unitId: string;
  public institutionName: string;
  public unitName: string;
  public units: any;
  public jsonDeterminants: string;
  public showDeterminants: boolean = false;
  public showUnits: boolean = false;
}
